import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { UserService } from '../../services/user/user.service';
import { DisplayService } from '../../services/display/display.service';

@Component({
	selector: 'pcm-data-page-user',
	templateUrl: './data-page-user.component.html',
	styleUrls: ['./data-page-user.component.scss']
})
export class DataPageUserComponent implements OnInit {

	dataObj = this.configService.userDataObj;
	dataConfig;
	title = 'User Details';

	constructor(
		private router: Router,
		public dataService: DataService,
		private userService: UserService,
		private configService: ConfigService,
		private displayService: DisplayService
	) { }

	selectedRoles;

	ngOnInit() {
		console.log('INIT USER PAGE', this.dataService.userDetails);
		this.dataConfig = this.configService.getDataObj(this.dataObj);
	}

	pageFormSubmit(event) {
		console.log('PAGE FORM SUBMIT', event, this.dataService.userDetails);
		this.dataService.userDetails = event.data;
		this.userService.submitUserEdits(this);
	}

	userSuccess() {
		console.log('USER SUCCESS CALL');
		const self = this;
		const delay = setTimeout(function(){
			self.router.navigateByUrl('admin-users');
		}, 2000);
	}

}
